import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type CreateRfqBuilderPayload = {
  answer: string;
};

export type CreateRfqBuilderResponse = {
  rfq_id: number;
  name: string;
  short_name: string;
  description: string;
};

export const createRfqBuilder = async (
  payload: CreateRfqBuilderPayload
): Promise<CreateRfqBuilderResponse> => {
  try {
    const formData = new FormData();

    formData.append('answer', payload.answer);

    const { data } = await apiService.post(`/rfq/create/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
